import React, { useContext, useRef, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { getSimulatorOutput } from 'gqlQueries/priceSimulator';
import { simulationKpiParser, simulationOutputDataParser } from 'parser/priceSimulator/priceSimulatorDataParser';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
const errorMessage: string = 'Something went wrong!';

function useFetchSimulatorOutput({ kpiMetrictsState, setKpiMetrictsState }: any) {
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<null | string>(null);
    const [data, setData] = useState<Array<any>>([]);
    const [count, setCount] = useState<number>(0);
    const offsetRef = useRef(0);
    const { appConfig } = useContext(UserContext);
    const { outputKeyMapping, recommendationKeyMapping } = getConfig('priceSimulator', appConfig);
    const [fetchSimulatorOutput] = useLazyQuery(getSimulatorOutput, {
        onCompleted: onFetchComplete,
        onError: onFetchError,
    });

    //called when fetching is complete
    function onFetchComplete(payload: any) {
        try {
            const { getSimulatorOutputValues } = payload;

            //if data present parse it
            if (getSimulatorOutputValues?.metricsData.length > 0) {
                setCount(getSimulatorOutputValues?.count || 0);

                const parsedData: any = simulationOutputDataParser(
                    getSimulatorOutputValues?.metricsData,
                    outputKeyMapping,
                );
                const parsedKpisData: any = simulationKpiParser(
                    getSimulatorOutputValues?.totalKpisData,
                    kpiMetrictsState,
                );
                setKpiMetrictsState(parsedKpisData);

                setData([...parsedData]);
                return;
            }
            setData([]);
        } catch (error) {
            console.error(errorMessage, error);
            onFetchError(error);
        } finally {
            setLoading(false);
        }
    }

    //called when API throws an error
    function onFetchError(error: any = errorMessage) {
        setData([]);
        setLoading(false);
        setError(error);
    }

    return {
        loading,
        error,
        data,
        fetchSimulatorOutput: (variables: any) => {
            offsetRef.current = variables.variables.offset;
            setLoading(true);
            setError(null);
            fetchSimulatorOutput(variables);
        },
    };
}

export { useFetchSimulatorOutput };
